import { readCookie } from "./readCookie.ts";

/**
 * Extracts the GA4 client ID from the `_ga` cookie.
 *
 * The cookie has the shape `GA<version>.<domainDepth>.<clientId>.<firstVisit>`
 * (e.g. `GA1.1.1234567890.1713180000`). GA4 treats the last two dot-separated
 * segments as the client ID (`<clientId>.<firstVisit>`), so we return that
 * pair joined by a dot.
 *
 * Used as a `cid` fallback in Walker OS events when the collector hasn't
 * populated `event.user.id` yet (e.g. pre-consent or first pageview).
 */
export function getGAClientId(): string | undefined {
  const value = readCookie((name) => name === "_ga");
  if (!value) return undefined;

  const parts = value.split(".");
  return parts.length >= 4 ? `${parts[2]}.${parts[3]}` : undefined;
}
